import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  get_candidate_profile_data_action,
  get_candidate_all_educational_data_action,
  get_candidate_all_professional_data_action,
  update_candidate_profile_action,
  get_candidate_education_by_id_data_action,
  get_candidate_profession_by_id_data_action,
  update_candidate_education_by_id_data_action,
  update_candidate_profession_by_id_data_action,
  create_candidate_education_data_action,
  create_candidate_profession_data_action,
  delete_candidate_education_by_id_data_action,
  delete_candidate_profession_by_id_data_action,
  create_candidate_skills_data_action,
  delete_candidate_skill_by_id_data_action,
  update_user_meta_data_action,
} from "../../../redux/_actions";

import { useSelector } from "react-redux";
import {
  COMPANY_INDUSTRY_CHOICES,
  COUNTRY,
  EDUCATION,
  GENDER,
  STATE,
  CITY,
  SEARCHKEYWORDS,
  educationFormSchema,
  professionFormSchema,
} from "./constants";
import { validateUrl } from "../../../_helpers/validators";

function useCandidateProfile(props) {
  const [userData, setUserData] = useState({});
  const [allEducationalData, setAllEducationalData] = useState([]);
  const [allProfessionalData, setAllProfessionalData] = useState([]);
  const [educationFormData, setEducationFormData] = useState({});
  const [professionFormData, setProfessionFormData] = useState({});
  const [loadingEducation, setLoadingEducation] = useState(false);
  const [loadingprofession, setLoadingProfession] = useState(false);

  //drop down choices
  const [companyIndustry, setCompanyIndustry] = useState([]);
  const [gender, setGender] = useState([]);
  const [country, setCountry] = useState([]);
  const [education, setEducation] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [suggestedCountries, setSuggestedCountries] = useState(COUNTRY);
  const [suggestedStates, setSuggestedStates] = useState([]);
  const [suggestedCities, setSuggestedCities] = useState([]);
  const [showEducation, setShowEducation] = useState(false);
  const [showProfession, setShowProfession] = useState(false);
  const [searchKeywordsSuggestions, setSearchKeywordsSuggestions] = useState(
    []
  );
  const [searchKeywordString, setSearchKeywordString] = useState("");
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);
  const [formInputsError, setFormInputsError] = useState({});
  const [educationStartDate, setEducationStartDate] = useState();
  const [educationEndDate, setEducationEndDate] = useState();
  const [professionStartDate, setProfessionStartDate] = useState();
  const [professionEndDate, setProfessionEndDate] = useState();
  const [checked, setChecked] = useState(false);

  const dispatch = useDispatch();

  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );
  const { userProfessionalData } = useSelector(
    (state) => state.get_candidate_all_professional_data_reducer
  );
  const { userEducationalData } = useSelector(
    (state) => state.get_candidate_all_educational_data_reducer
  );
  const { userEducationByIdData } = useSelector(
    (state) => state.get_candidate_education_by_id_data_reducer
  );
  const { userProfessionByIdData } = useSelector(
    (state) => state.get_candidate_profession_by_id_data_reducer
  );

  const { userSkillsData } = useSelector(
    (state) => state.get_candidate_all_skills_data_reducer
  );
  const { newUserSkillData } = useSelector(
    (state) => state.create_candidate_skills_data_reducer
  );

  //set dropdown choices
  useEffect(() => {
    setCompanyIndustry(COMPANY_INDUSTRY_CHOICES);
    setCountry(COUNTRY);
    setEducation(EDUCATION);
    setGender(GENDER);
    setStates(STATE);
    setCities(CITY);
  }, []);

  useEffect(() => {
    if (userProfileData?.data) {
      setUserData(userProfileData?.data);
    }
  }, [userProfileData]);
  
  useEffect(() => {
    if (userEducationalData?.data) {
      setAllEducationalData(userEducationalData?.data);
    }
  }, [userEducationalData]);
  useEffect(() => {
    if (userProfessionalData?.data) {
      setAllProfessionalData(userProfessionalData?.data);
    }
  }, [userProfessionalData]);
  useEffect(() => {
    if (userSkillsData?.data) {
      let data = userSkillsData?.data;
      setSkillsTagsAdded(data);
    }
  }, [userSkillsData]);

  //suggested cities and countries
  useEffect(() => {
    if (professionFormData?.country) {
      let states = suggestedCountries.find(
        (c) => c.value === professionFormData?.country
      );
      let cities = states.states.find(
        (s) => s.value === professionFormData?.state
      );
      setSuggestedCities(cities?.cities);
      setSuggestedStates(states.states);
    }
  }, [professionFormData]);

  //suggested cities and countries
  useEffect(() => {
    if (newUserSkillData?.data) {
      let skills = skillsTagsAdded;
      skills.push(newUserSkillData?.data);
      setSkillsTagsAdded(skills);
    }
  }, [newUserSkillData]);

  useEffect(() => {
    if (userEducationByIdData?.data) {
      let data = userEducationByIdData?.data;
      data["college_degree"] =
        data["college_degree_name"] && data["college_degree_name"];
      data["school"] = data["school_name"] && data["school_name"];
      data["field_of_study"] =
        data["field_of_study_name"] && data["field_of_study_name"];
      data["school"] = data["school_name"] && data["school_name"];
      setEducationFormData(userEducationByIdData?.data);
    }
  }, [userEducationByIdData]);

  useEffect(() => {
    if (userProfessionByIdData?.data) {
      let data = userProfessionByIdData?.data;
      data["company"] = data["company_name"] && data["company_name"];
      data["city"] = data["city_name"] && data["city_name"];
      data["country"] = data["country_name"] && data["country_name"];
      data["state"] = data["state_name"] && data["state_name"];
      data["currently_working_here"] =
        data["currently_working_here"] && data["currently_working_here"];
      setChecked(data?.currently_working_here);
      setProfessionFormData(userProfessionByIdData?.data);
    }
  }, [userProfessionByIdData]);

  //on input blurr for profile
  const onInputBlur = async (e, field) => {
    let value = e.target.value;
    let key = e.target.name;
    let error = {};
    let data = {};

    if (key === "country") {
      data["state"] = "";
      data["city"] = "";
    }
    if (key === "state") {
      data["country"] = userData.country_name;
      data["city"] = "";
    }
    if (key === "city") {
      data["country"] = userData.country_name;
      data["state"] = userData.state_name;
    }
    data[key] = value;

    if (
      key === "candidate_website" ||
      key === "linkedin_url" ||
      key === "github_url"
    ) {
      if (validateUrl(value)) {
        await dispatch(update_candidate_profile_action(data));
        setFormInputsError({});
      } else {
        let url_error = validateUrl(value);
        error = {
          ...formInputsError,
          key: url_error,
        };
        error[key] = "Enter Valid Url";
        setFormInputsError(error);
      }
    } else {
      await dispatch(update_candidate_profile_action(data));
    }
  };

  // on location change
  const onLocationChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    let data = professionFormData;

    if (name === "country") {
      let states = COUNTRY.find((c) => c.key === value);
      setSuggestedStates(states.states);
      data["state"] = "";
      data["state_name"] = "";
      data["city"] = "";
      data["city_name"] = "";
    }

    if (name === "state") {
      let cities = suggestedStates.find((s) => s.key === value);
      setSuggestedCities(cities.cities);
      data["city"] = "";
      data["city_name"] = "";
    }
    data[name] = value;
    setProfessionFormData(data);
  };

  // modal opens or close
  const toggleModal = async (field) => {
    setProfessionFormData({});
    setEducationFormData({});
    switch (field) {
      case "education":
        setShowEducation(true);
        setShowProfession(false);
        return;
      case "profession":
        setShowProfession(true);
        setShowEducation(false);
        return;
      default:
        return;
    }
  };

  // edit user education and experience
  const editUserEducationExperience = async (field, id) => {
    toggleModal(field);
    switch (field) {
      case "education":
        await dispatch(get_candidate_education_by_id_data_action(id));
        return;
      case "profession":
        await dispatch(get_candidate_profession_by_id_data_action(id));
        return;
      default:
        return;
    }
  };

  // delete user education and experience
  const deleteUserEducationExperience = async (field, id) => {
    switch (field) {
      case "education":
        await dispatch(delete_candidate_education_by_id_data_action(id));
        setLoadingEducation(true);
        await dispatch(get_candidate_all_educational_data_action());
        setLoadingEducation(false);
        return;
      case "profession":
        await dispatch(delete_candidate_profession_by_id_data_action(id));
        setLoadingProfession(true);
        await dispatch(get_candidate_all_professional_data_action());
        setLoadingProfession(false);
        return;
      default:
        return;
    }
  };

  // onDateChange

  const onDateChange = async (field, date, key) => {
    let convertDate = (date) => {
      var date = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };
    let formatDate = convertDate(date);

    switch (field) {
      case "personal":
        await dispatch(update_candidate_profile_action({ dob: formatDate }));
        return;
      case "education":
        let educationStartDateObj = educationFormData;
        educationStartDateObj[key] = formatDate;
        setEducationStartDate(date);
        setEducationEndDate(date);
        setEducationFormData(educationStartDateObj);
        return;
      case "profession":
        let professionStartDateObj = professionFormData;
        professionStartDateObj[key] = formatDate;
        setProfessionFormData(professionStartDateObj);
        setProfessionStartDate(date);
        setProfessionEndDate(date);
        return;
      default:
        return;
    }
  };

  // submit education and experience
  const onSubmitForm = async (field) => {
    switch (field) {
      case "education":
        setLoadingEducation(true);
        if (validateForm(field)) {
          if (educationFormData.id === undefined)
            await dispatch(
              create_candidate_education_data_action(educationFormData)
            );
          else {
            await dispatch(
              update_candidate_education_by_id_data_action(
                educationFormData,
                educationFormData.id
              )
            );
          }
          await dispatch(get_candidate_all_educational_data_action());
          setShowEducation(false);
          setEducationFormData({});
        }
        setLoadingEducation(false);
        return;
      case "profession":
        setLoadingProfession(true);
        if (validateForm(field)) {
          if (professionFormData.id === undefined)
            await dispatch(
              create_candidate_profession_data_action(professionFormData)
            );
          else {
            await dispatch(
              update_candidate_profession_by_id_data_action(
                professionFormData,
                professionFormData.id
              )
            );
          }
          await dispatch(get_candidate_all_professional_data_action());
          setShowProfession(false);
          setProfessionFormData({});
        }
        setLoadingProfession(false);
        return;

      default:
        return;
    }
  };

  const onEducationFormDataChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = {};
    if (educationFormData !== undefined) data = educationFormData;

    // set data values
    data[name] = value;
    setEducationFormData(data);
  };

  const onProfessionFormDataChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let data = {};
    if (professionFormData !== undefined) data = professionFormData;

    // set data values
    data[name] = value;
    setProfessionFormData(data);
  };

  const handleClose = () => {
    setShowEducation(false);
    setShowProfession(false);
    setFormInputsError({});
    setChecked(false);
  };

  // call skills api
  const callSearchKeywordApi = (text) => {
    if (text.length !== 0) {
      const filterData = SEARCHKEYWORDS.filter((item) => item.includes(text));
      setSearchKeywordsSuggestions(filterData);
    } else setSearchKeywordsSuggestions([]);
  };
  // search for skills
  const onSearchKeywordChange = (e) => {
    let text = e.target.value;
    setSearchKeywordString(text);
    callSearchKeywordApi(text);
  };

  // delete skills tags
  const onKeywordsTagsDelete = async (tag) => {
    let skills = skillsTagsAdded.filter((item) => item !== tag);
    setSkillsTagsAdded(skills);
    await dispatch(delete_candidate_skill_by_id_data_action(tag.id));
  };

  // add new skills tags
  const onKeywordsTagsAddition = async (tag) => {
    setSearchKeywordString();
    await dispatch(create_candidate_skills_data_action({ skill: tag }));
    setSearchKeywordsSuggestions([]);
  };

  // validate form inputs
  const validateForm = (field) => {
    let formSchema =
      field === "education" ? educationFormSchema : professionFormSchema;
    let errors = {};
    let valid = { isValid: true };
    let formData =
      field === "education" ? educationFormData : professionFormData;

    for (var key in formSchema) {
      if (
        formData[key] === undefined ||
        formData[key] === "" ||
        formData[key] === 0
      ) {
        errors[key] = `This field can not be empty.`;
        valid.isValid = false;
      }
    }
    if (
      formData["start_date"] !== undefined &&
      formData["end_date"] !== undefined
    ) {
      if (formData["start_date"] === formData["end_date"]) {
        errors["end_date"] = `Start Date and End Date can't be same`;
        valid.isValid = false;
      }
    }
    if(formData["currently_working_here"] === true){
      errors["end_date"] = null;
      valid.isValid = true;
    }
    setFormInputsError(errors);
    return valid.isValid;
  };

  const onCurrently = () => {
    let data = professionFormData;
    data["currently_working_here"] = !checked;
    setChecked(!checked);
    setProfessionFormData(data);
  };

  const onImageUpload = async (e,key) => {
    const file = e.target.files[0];
    const name = e.target.name
    const data = new FormData()
    data.append(name, file);
    await dispatch(update_user_meta_data_action(data))
    await dispatch(get_candidate_profile_data_action())
  };

  return {
    userData,
    allEducationalData,
    allProfessionalData,
    educationFormData,
    professionFormData,

    //drop down choices
    companyIndustry,
    gender,
    suggestedCities,
    suggestedCountries,
    suggestedStates,
    education,
    cities,
    states,
    country,
    showEducation,
    showProfession,
    searchKeywordString,
    searchKeywordsSuggestions,
    skillsTagsAdded,
    formInputsError,
    educationStartDate,
    educationEndDate,
    professionEndDate,
    professionStartDate,
    loadingEducation,
    loadingprofession,
    checked,

    // onLocationChange,
    onInputBlur,
    // toggleEdit,
    onDateChange,
    onEducationFormDataChange,
    onProfessionFormDataChange,
    editUserEducationExperience,
    onSubmitForm,
    onLocationChange,
    handleClose,
    onSearchKeywordChange,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    deleteUserEducationExperience,
    toggleModal,
    onCurrently,
    onImageUpload
  };
}
export default useCandidateProfile;
